import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { UpgradeModule } from '@angular/upgrade/static';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ToastrModule } from 'ngx-toastr';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { TextFieldModule } from '@angular/cdk/text-field';

import { angularJsModule } from 'OpsCenter/app.angularjs.module';
import { AuthModule } from 'OpsCenter/auth/auth.module';
import { ChainsModule } from 'OpsCenter/chains/chains.module';
import { SharedModule } from 'OpsCenter/shared/shared.module';
import ImportModule from 'OpsCenter/merchants/importing/import.module';
import RevertStatusModule from 'OpsCenter/merchants/revert-status/revert-status.module';
import { MerchantsModule } from 'OpsCenter/merchants/merchants.module';
import { SeoModule } from 'OpsCenter/seo/seo.module';
import { TagsModule } from 'OpsCenter/tags/tags.module';
import { UtilModule } from 'Utilities/util.module';
import { Covid19Module } from 'OpsCenter/ops-support/covid-19/covid-19.module';
import { BulkSettingsModule } from 'OpsCenter/ops-support/settings/bulk-settings.module';
import { MerchantCleanUpModule } from 'OpsCenter/ops-support/merchant-clean-up/merchant-clean-up.module';
import { AgentsModule } from 'OpsCenter/agents/agents.module';
import { MerchantToolsModule } from 'OpsCenter/merchant-tools/merchant-tools.module';
import { MerchantBulkCreateModule } from 'OpsCenter/ops-support/merchant-bulk-create/merchant-bulk-create.module';
import { LoyaltyPointsModule } from 'OpsCenter/ops-support/loyalty-points/loyalty-points.module';

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    UpgradeModule,
    AuthModule,
    TagsModule,
    UtilModule,
    MerchantsModule,
    HttpClientModule,
    SeoModule,
    Covid19Module,
    LoyaltyPointsModule,
    BulkSettingsModule,
    MerchantCleanUpModule,
    AgentsModule,
    SharedModule,
    ChainsModule,
    ImportModule,
    RevertStatusModule,
    TranslateModule.forRoot(),
    NgbModule,
    ToastrModule.forRoot(),
    MerchantToolsModule,
    DragDropModule,
    TextFieldModule,
    MerchantBulkCreateModule,
  ],
})
export class AppModule {
  constructor(private upgrade: UpgradeModule, private translate: TranslateService) {
    translate.setDefaultLang('en');
    translate.use('en');
    translate.setTranslation('en', require('../environment/lang/en.json'));
  }

  /**
   * Helper function to manually bootstrap the angularjs legacy module
   * @return {void}
   */
  public ngDoBootstrap(): void {
    this.upgrade.bootstrap(document.documentElement, [angularJsModule.name]);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.angular.module.ts